import { render, staticRenderFns } from "./new_courier.vue?vue&type=template&id=02bc07c5"
import script from "./new_courier.vue?vue&type=script&lang=js"
export * from "./new_courier.vue?vue&type=script&lang=js"
import style0 from "./new_courier.vue?vue&type=style&index=0&id=02bc07c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports